import instance from './require'

// 登录模块接口
const login = {
  // 验证码接口
  getCaptcha() {
    return instance.get('supply/login/captcha?refresh=true').then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 后台管理 手机验证码接口
  getMobileCode(data) {
    return instance.post('supply/login/send-sms', data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },

  // 手机端 手机验证码接口
  getNewMobileCode(name, value, data) {
    return instance.post(`newm/index/send-sms?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 手机端登录接口  账号密码
  loginPassword(name, value, data) {
    return instance.post(`newm/index/login-password?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 手机端登录接口 验证码
  loginCode(name, value, data) {
    return instance.post(`newm/index/set-mobile?${name}=${value}`, data).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
  // 退出登录
  loginOut(name, value) {
    return instance.get(`newm/member/index/logout?${name}=${value}`).then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },
}

export default login



// WEBPACK FOOTER //
// ./src/utils/login.js